import type { FaireProductEntity } from "../../entity_types/product";

export const p_xmedg6qxyq: FaireProductEntity = {
  token: "p_xmedg6qxyq",
  type: "product",
  name: "Fragrance Free Natural Diaper Cream",
  brandToken: "b_dvnws1tv58",
  brandName: "Zoey Naturals",
  imageUrl: "https://cdn.faire.com/fastly/3ba8930f76555c3bf8f980c09a20c4357ab39bb0907b73cd26f01b97aa1e4135.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fdca1e79a104e919f989c9a4902aa33b9c5adef87b2612890bfd5c98bbea74a7.jpeg",
    "https://cdn.faire.com/fastly/68c49e176259880243ab9ac32577ef3798e25dd6e440169d3e5f7844e38ab22a.jpeg",
    "https://cdn.faire.com/fastly/6abd4f54648989a5af2ac65a7024efdfb7a8de35087cb0ba52c2a87ef9603b10.png",
    "https://cdn.faire.com/fastly/d75220498b5ae265b7a9eaba43f95e6d1f8348bde53b457a0bfa81d2016faaa2.png",
    "https://cdn.faire.com/fastly/31cd57c7dcf9c36a4225a08e609fe26d1ea3926b8df1e2aa751393fa8964756d.png",
    "https://cdn.faire.com/fastly/08b2ab4cea56a522e7fe18a2aff7397dbb7a6e6f2b6ed5e0ba1f6163e5fb1616.jpeg",
    "https://cdn.faire.com/fastly/c026778bec36d0f3fafc13f9775b41e727e71940109daf53bd2a6c4d20d12360.png",
    "https://cdn.faire.com/fastly/494b79b465c39730aaf4db3a12cd5206e3cd565aead4045ebf3d02cbf460ffc8.png",
    "https://cdn.faire.com/fastly/3b8d29ad0011a7edf42066a9b1ad0bc108ac0798ddf38e75a26b0502311bc695.jpeg",
    "https://cdn.faire.com/fastly/702bac3ddd954808e8237fe63e51d91f67d3b7681f36c3b48780705c128e3106.jpeg",
    "https://cdn.faire.com/fastly/2d3d1aadcdbfb138bdff21d7382e58e2fbedd1d9373c7ccc7415accbbf09e7e5.jpeg",
    "https://cdn.faire.com/fastly/b7fd7ff28fbd2d3c57f08f38b6735c453fc05ae37adc7be6bd6f19bbda56c21d.jpeg",
    "https://cdn.faire.com/fastly/fce0c8f0333d1d5ae24b23d01239c90cba8f16791b5ba2549eda159721885ec5.png"
  ],
  priceDollars: 9.7,
  description: "Our Pediatrician and Dermatologist tested and approved Fragrance Free Natural Diaper Cream is the ultimate defense against rashes. Our cream forms a protective layer that allows skin to heal. Formulated with Non-Nano Zinc Oxide to treat and prevent diaper rash, beeswax to soothe irritated skin, shea and cocoa butter to nourish delicate skin, and avocado oil to prevent and relieve dryness. Hypoallergenic, paraben-free, phthalate-free, and made with love in the USA. \n\n•\tNatural Diaper Cream with Zinc Oxide\n•\tHypoallergenic Formula\n•\tTreats and Prevents Diaper Rash\n•\tEnriched with Shea Butter and Avocado Oil\n•\tFragrance-Free for Sensitive Skin\n•\tParaben-Free, Phthalate-Free, Harsh Chemical Free\n•\tMade with Plant-Based Ingredients\n•\tAward Winning\n•\tPediatrician and Dermatologist Tested and Approved\n•\tProudly Made in the USA\n\nLeaping Bunny Certified Cruelty-Free",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:54.644Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
